var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "text-caption text-secondary grey--text text--darken-1 text-center"
  }, [_vm._v(" © " + _vm._s(_setup.year) + ", Puerto Rico Supplies Group ")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };